export default __webpack_public_path__ + "static/16-4c9b5156263c0a0993edc5edbaf02b06.png";